import { createUseApiQuery, type ApiQueryErrorShape } from '@piaas/piaas-ui-toolkit/hooks';
import { useIntl } from 'react-intl';

import { useNotification } from '../components/notifications/useNotification';

import useGlobalLoader from './useGlobalLoader';

const useApiQuery = createUseApiQuery({
  useNotify: () => useNotification().push,
  useLoader: () => {
    const { startContextLoading, stopContextLoading } = useGlobalLoader();
    return { start: startContextLoading, stop: stopContextLoading };
  },
  useResolveErrorMessage: () => {
    const intl = useIntl();

    return (error: ApiQueryErrorShape, fallback: string): string => {
      const status = error.status !== undefined ? String(error.status) : undefined;
      const statusFallback = status
        ? intl.formatMessage({ id: status, defaultMessage: error.message ?? status })
        : fallback;

      return intl.formatMessage({
        id: error.message ?? 'defaultErrorMessage',
        defaultMessage: statusFallback,
      });
    };
  },
});

export default useApiQuery;
